exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-height[data-v-430c3146]{height:100vh}.flex-center[data-v-430c3146]{align-items:center;display:flex;justify-content:center}.position-ref[data-v-430c3146]{position:relative}", ""]);

// exports
